import { Component, HostBinding, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'title-section',
  imports: [],
  templateUrl: './title-section.component.html',
  styleUrl: './title-section.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  encapsulation: ViewEncapsulation.None,
})
export class TitleSectionComponent {
  @HostBinding('style.display') display = 'flex';
  @HostBinding('style.justify-content') justify = 'space-between';
  @HostBinding('style.align-items') align = 'baseline';
}
